import header from './header.vue'

const myheader = {
    install : function(Vue){
        Vue.component('myheader',header)
    }
}
export default myheader